import GoogleMap from "../utils/map";
import helpers from "../utils/helpers";

function hasPreferencesConsent() {
  return (
    window._solepharmPreferencesConsent ||
    (window.silktideConsentManager &&
      typeof window.silktideConsentManager.getConsentChoice === "function" &&
      window.silktideConsentManager.getConsentChoice("preferences"))
  );
}

const Contacts = {
  init() {
    this.events();

    const mapEl = $("#map-wrap");
    if (mapEl.length) {
      Contacts.renderMap(mapEl);
    }
  },

  events() {
    if ($("select").length) {
      $("select").selectric();
    }

    $("#contact-form").on("submit", (e) => {
      e.preventDefault();

      Contacts.validate();
    });
  },

  validate() {
    const formEl = $("#contact-form");

    formEl.addClass("loading");

    $(".error", this).removeClass("error");

    if (helpers.validate(formEl)) {
      setTimeout(() => {
        Contacts.recaptcha();
      }, 500);
    } else {
      formEl.removeClass("loading");
    }
  },

  recaptcha() {
    if (typeof window._solepharmWhenRecaptchaReady === "function") {
      window._solepharmWhenRecaptchaReady((ready) => {
        if (ready && typeof grecaptcha !== "undefined") {
          grecaptcha.ready(() => {
            grecaptcha.execute(recaptcha_key, { action: "submit" }).then((token) => {
              Contacts.submit(token);
            });
          });
        } else {
          const formEl = $("#contact-form");
          formEl.removeClass("loading");
          const msg = (typeof translations !== "undefined" && translations.recaptcha_consent_required) || "Please enable Preferences cookies to use this form.";
          formEl.find(".form-status").text(msg).removeClass("hidden").addClass("error");
        }
      });
      return;
    }
    grecaptcha.ready(() => {
      grecaptcha.execute(recaptcha_key, { action: "submit" }).then((token) => {
        Contacts.submit(token);
      });
    });
  },

  submit(token) {
    const formEl = $("#contact-form");

    const formData = new FormData(formEl[0]);
    formData.append("token", token);

    formEl.find("button").addClass("loading");
    formEl.find(".form-status").addClass("hidden");

    $.ajax({
      url: ajaxurl,
      type: "POST",
      data: formData,
      processData: false,
      contentType: false,
    })
      .done((response) => {
        if (response.success) {
          formEl[0].reset();

          formEl.find(".errors-wrap").remove();
          formEl.find(".form-status").removeClass("error");
        } else {
          formEl.find(".form-status").addClass("error");
        }

        formEl
          .find(".form-status")
          .text(response.data.message)
          .removeClass("hidden");
      })
      .always(() => {
        formEl.removeClass("loading");
        formEl.find("button").removeClass("loading");
      });
  },

  renderMap(mapEl) {
    if (!hasPreferencesConsent()) {
      const msg =
        (typeof translations !== "undefined" && translations.map_consent_required) ||
        "Please enable Preferences cookies to view the map.";
      mapEl.empty().append($('<p class="map-consent-msg"></p>').text(msg));
      return;
    }

    const location = {
      lat: mapEl.data("lat"),
      lng: mapEl.data("lng"),
    };

    let zoom = parseInt(mapEl.data("zoom"));
    if (!zoom) {
      zoom = 16;
    }

    const pin = mapEl.data("pin");

    const map_options = {
      zoom,
      center: location,
      scrollwheel: false,
      mapTypeControl: false,
      fullscreenControl: false,
      streetViewControl: false,
      styles: GoogleMap.styles,
    };

    const map = new google.maps.Map(mapEl[0], map_options);

    map.markers = [];

    const center = new google.maps.LatLng(location.lat, location.lng);

    // Marker and Icon.
    const marker_options = {
      position: center,
      clickable: false,
      map: map,
      animation: google.maps.Animation.DROP,
    };

    if (pin) {
      marker_options.icon = pin;
    } else {
      var icon = {
        size: new google.maps.Size(30, 40),
        path: "M15,40Q30,23.886,30,15.388A15.2,15.2,0,0,0,15,0,15.2,15.2,0,0,0,0,15.388Q0,23.886,15,40Z",
        fillColor: $(".header").css("background-color"),
        fillOpacity: 1,
        anchor: new google.maps.Point(15, 40),
        strokeWeight: 0,
        scale: 1,
      };
      marker_options.icon = icon;
    }

    const marker = new google.maps.Marker(marker_options);

    map.markers.push(marker);
  },
};

export default Contacts;
